





























































































import { Component, Prop, Mixins, Emit, Ref } from "vue-property-decorator";
import RulesMixin from "#/mixins/rulesMixin";
import AxiosMixin from "@/mixins/axiosMixin";
import {
  BiaggregateCauseMeasure,
  DefaultBiaggregateCauseMeasure,
} from "#/model/biaggregate";
import { Choice, VForm } from "@/types";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";

@Component({
  components: {
    AppAuthButton,
  },
})
export default class CauseMeasureEdit extends Mixins(RulesMixin, AxiosMixin) {
  /** フォームバリデーション用 */
  @Ref("form") private readonly form!: VForm;

  /** 主因仮説/打ち手コメントマスタ */
  @Prop({ default: () => DefaultBiaggregateCauseMeasure() })
  causeMeasure!: BiaggregateCauseMeasure;

  /** 指標種類選択肢 */
  @Prop({ default: () => [] }) metricsTypes!: Choice[];

  /** 指標レベル選択肢 */
  @Prop({ default: () => [] }) metricsLevels!: Choice[];

  /** 保存ボタン押下時 */
  @Emit("click:save") private clickSave() {
    return;
  }

  /** 削除ボタン押下時 */
  @Emit("click:delete") private clickDelete() {
    return;
  }

  /** キャンセル時 */
  @Emit("click:cancel") private clickCancel() {
    return;
  }

  /** 保存ボタンクリック */
  private async onClickSave() {
    if (!this.form.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }
    if (await this.$openConfirm("保存しますか?")) {
      this.clickSave();
    }
  }

  /** キャンセルボタンクリック */
  private async onClickCancel() {
    if (
      await this.$openConfirm(
        "編集を終了します。\n編集中の場合は内容が破棄されます。"
      )
    ) {
      this.clickCancel();
    }
  }

  /** 削除ボタンクリック */
  private async onClickDelete() {
    if (await this.$openConfirm("削除します。よろしいですか？")) {
      this.clickDelete();
    }
  }
}
